import React, { useEffect, useState } from 'react';
import Select from '../../../components/UI/Select';
import TextAreaUI from '../../../components/UI/TextAreaUI';
import ButtonUI from '../../../components/UI/ButtonUI';
import { Row, Modal, Button } from 'react-materialize';
import { isNullOrEmpty, translate } from '../../../utils/util';
import { validateInputsRequired, onValueChange } from '../../../utils/handleChangeHooks';

const ConfirmModalPackList = (props) => {
    const defaultValues = {
        justificationId: null,
        justificationText: ""
    }
    const [justification, setJustification] = useState([]);
    const [required, setRequired] = useState(true);
    const [model, setModel] = useState(defaultValues);

    useEffect(() => {
        if (props.justifications?.items) {
            const filter = props.justifications.items.filter((f) => f.justificationTypeId === 5) || [];
            if (filter.length > 0) {
                const data = filter.map((i) => { return { id: i.justificationId, text: i.description } }) || [];
                setJustification([...data])
            }

        }
        return () => {
            setRequired(true);
            setModel({ ...defaultValues });
        }
        // eslint-disable-next-line
    }, [props.justifications, props.open]);

    useEffect(() => {
        if (isNullOrEmpty(model.justificationText) && !model.justificationId) {
            return setRequired(true);
        }
        return setRequired(false)
        // eslint-disable-next-line
    }, [model]);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const onConfirm = () => {
        if (props.onConfirm && validateInputsRequired("formInput")) {
            props.onConfirm(model);
            close();
        }
    }

    const onCancel = () => {
        if (props.onCancel) {
            props.onCancel();
        }
        close();
    };

    const close = () => {
        if (props.onClose) {
            props.onClose();
        }
    }

    return (
        <Modal
            open={props.open}
            id={props.id || 'ModalPackList'}
            actions={
                <Row className="center" style={{ height: "60%" }}>
                    <Button onClick={onCancel} className="col s6 btn waves-effect waves-light btn-flat" modal="close" disabled={props.disabledCancel}>
                        {props.btnCancel ? props.btnCancel : translate('cancel', 'general')}
                    </Button>
                    <ButtonUI onClick={onConfirm} text={props.btnConfirm ? props.btnConfirm : translate('confirm', 'general')} />
                </Row>
            }
        >
            <div>
                {
                    props.open &&
                    <>
                        <Row className="center">
                            <div className="sixth-text-color center">
                                <span className="title col s12">{props.title}</span>
                                <span className="col s12" >{props.content}</span>
                            </div>
                        </Row>
                        <div id="formInput" className="row" style={{ marginBottom: '0px' }}>
                            <div className="padding col s12">
                                <Select
                                    required={required}
                                    defaultValue={model?.justificationId || ''}
                                    id="justificationId"
                                    name="justificationId"
                                    placeHolder={translate("line-picking:linepicking.justification-Id")}
                                    change={onChange}
                                    data={justification}
                                />
                            </div>
                            <div className="padding col s12">
                                <TextAreaUI
                                    required={required}
                                    defaultValue={model?.justificationText || ''}
                                    id="justificationText"
                                    name="justificationText"
                                    label= {translate("line-picking:linepicking.justification")}
                                    onChange={onChange}
                                    data-length="120" />

                            </div>
                        </div>
                    </>
                }
            </div>
        </Modal>
    )
}

export default ConfirmModalPackList;
